<template lang="pug">
  v-container.pa-0
    v-row.pa-0(v-if="options.mode=='edit'" no-gutters)
      v-col.pa-0(cols='12')
        | LAYOUT:
        div
          .toolbar
            v-btn(icon small outlined dark color='light-blue' @click='addTable')
              v-icon mdi-plus-box
            v-btn(icon small outlined color='light-blue' dark @click='addSeat')
              v-icon mdi-plus-box-multiple
            v-btn(icon small outlined color='light-blue' dark @click='cloneTable')
              v-icon(alt='clonetable') mdi-repeat-once
            v-btn(icon small outlined color='light-blue' dark @click='removeItem')
              v-icon mdi-delete
            v-icon |
            v-btn(icon small color='light-blue' dark outlined @click='rotate(45)' :disabled="activeItem &&( (activeItem.type!='table')||(activeItem.type=='table'&&activeItem.angle==45))")
              v-icon mdi-rotate-right
            v-btn(icon small outlined color='light-blue' dark @click='rotate(-45)' :disabled="activeItem &&( (activeItem.type!='table')||(activeItem.type=='table'&&activeItem.angle==-45))")
              v-icon mdi-rotate-left
            v-btn(icon small outlined color='light-blue' dark @click='toggleShape')
              v-icon mdi-rounded-corner
            br
            v-btn(icon small outlined color='light-blue' dark @click='moveUp')
              v-icon mdi-chevron-up
            v-btn(icon small outlined color='light-blue' dark @click='moveDown')
              v-icon mdi-chevron-down
            v-btn(icon small outlined color='light-blue' dark @click='moveLeft')
              v-icon mdi-chevron-left
            v-btn(icon small outlined color='light-blue' dark @click='moveRight')
              v-icon mdi-chevron-right
            v-icon |
            v-btn(icon small outlined color='light-blue' dark @click='scaleDownX')
              v-icon mdi-page-first
            v-btn(icon small outlined color='light-blue' dark @click='scaleUpX')
              v-icon mdi-page-last
            v-btn(icon small outlined color='light-blue' dark @click='scaleUpY')
              v-icon mdi-unfold-more-horizontal
            v-btn(icon small outlined color='light-blue' dark @click='scaleDownY')
              v-icon mdi-unfold-less-vertical
    v-row(justify-start align-content-start no-gutters)
      v-col(cols='12')
        .canvas
          svg(ref='svg' :width="zoomToFit ? '100%' : width" :height="zoomToFit ? '100%' : height" :viewbox="'0 -2 ' + width + ' ' + height" @mousemove='onMouseMove($event)' @mouseup='onMouseUp($event)' @click='onClickItem($event,{})')
            g(v-for='(table, tidx) in tables' :key='tidx' :transform="'translate('+table.x+', '+table.y+'),rotate('+ (table.angle||0)  +')'")
              text(:x='table.width/2' y='0' @click='onClickItem($event,table)' text-anchor='middle') T{{tidx+1}}
              rect(v-if="table.type=='table'" :x='0' :y='0' :rx='table.rx||5' :ry='table.ry||5' :width='table.width' :height='table.height' :font-size='table.height' :font-family='table.font' fill='#c19a6b' @click='onClickItem($event,table)')
              g(v-if='table.active')
                rect.ctrl-bounds(:x='0' :y='0' :rx='table.rx||5' :ry='table.ry||5' :width='table.width' :height='table.height' @click='onClickItem($event,table)' @_mouseout='onMouseUpRegion($event,table)' @mousedown='onMouseDownRegion($event,table)')
                g(@mousedown='onMouseDownHandles($event,table)')
                  rect.ctrl-rect(:width='tools.squaresize' :height='tools.squaresize' data-handleid='1' :x='0-tools.squaresize/2' :y='0-tools.squaresize/2')
                  rect.ctrl-rect(:width='tools.squaresize' :height='tools.squaresize' data-handleid='3' :x='table.width-tools.squaresize/2' :y='0-tools.squaresize/2')
                  rect.ctrl-rect(:width='tools.squaresize' :height='tools.squaresize' data-handleid='7' :x='0-tools.squaresize/2' :y='table.height-tools.squaresize/2')
                  rect.ctrl-rect(:width='tools.squaresize' :height='tools.squaresize' data-handleid='9' :x='table.width-tools.squaresize/2' :y='table.height-tools.squaresize/2')
              g(v-for='(seat, sidx) in table.seats' :key='sidx' :transform="'translate('+seat.x+', '+seat.y+')'")
                rect(v-if="seat.type=='seat'" :x='0' :y='0' :stroke="seat._serviceKey==options.serviceId ? 'white':''" :stroke-width="'2'" :width='seat.width' :height='seat.height' :font-size='seat.height' :font-family='seat.font' :fill="seat._serviceKey=='rx' ? 'yellow':seat._serviceKey?'red':'#90ee90'" @click='onClickItem($event,seat,tidx,sidx)')
                text(x='10' y='15' :fill="seat._serviceKey==options.serviceId ? 'white':'black'" @click='onClickItem($event,seat,tidx,sidx)' text-anchor='middle') {{sidx+1}}
                g(v-if='seat.active')
                  rect.ctrl-bounds(:x='0' :y='0' :width='seat.width' :height='seat.height' @click='onClickItem($event,seat,tidx,sidx)' @_mouseout='onMouseUpRegion($event,seat)' @mousedown='onMouseDownRegion($event,seat)')
                  g(@mousedown='onMouseDownHandles($event,seat)')
                    rect.ctrl-rect(:width='tools.squaresize' :height='tools.squaresize' data-handleid='1' :x='0-tools.squaresize/2' :y='0-tools.squaresize/2')
                    rect.ctrl-rect(:width='tools.squaresize' :height='tools.squaresize' data-handleid='3' :x='seat.width-tools.squaresize/2' :y='0-tools.squaresize/2')
                    rect.ctrl-rect(:width='tools.squaresize' :height='tools.squaresize' data-handleid='7' :x='0-tools.squaresize/2' :y='seat.height-tools.squaresize/2')
                    rect.ctrl-rect(:width='tools.squaresize' :height='tools.squaresize' data-handleid='9' :x='seat.width-tools.squaresize/2' :y='seat.height-tools.squaresize/2')

</template>

<script>
export default {
  name: "floorplan",
  props: {
    tables: Array,
    options: Object //mode=[edit, view],serviceId
  },
  data() {
    return {
      point: {},
      movetarget: null,
      activeItem: null,
      // tables: [],
      tools: {
        squaresize: 8,
        min_height: 30
      },
      zoomToFit: false
    };
  },
  computed: {
    width() {
      const xArray = this.tables
        ? this.tables.map(t => t.x + t.width - (t.angle ? 0.52 : 0) * t.height)
        : [];
      xArray.push(285); //ensure min 220 to keep two tables
      const maxX = Math.max(...xArray);
      const minX = 10;
      return maxX - minX + 20;
    },
    height() {
      const yArray = this.tables
        ? this.tables.map(t => t.y + t.height - (t.angle ? -0.52 : 0) * t.width)
        : [];
      yArray.push(160); //ensure min 160 to keep two tables
      const maxY = Math.max(...yArray);
      const minY = 10;
      return maxY - minY + 15;
    }
  },
  mounted() {
    window.addEventListener("keyup", this.onKeyUp);
  },
  methods: {
    addTable() {
      this.tables.push(this.createTable());
      this.activateDefaultItem();
    },
    addSeat() {
      if (this.activeItem) {
        if (this.activeItem.type === "seat") {
          //activate parent if seat is active
          this.activeItem.active = false;
          const parent = this.tables.filter(
            t => t.id === this.activeItem.parentId
          )[0];
          parent.active = true;
          this.activeItem = parent;
        }
        const maxSeats =
          (this.activeItem.height * this.activeItem.width) / (30 * 30);
        if (this.activeItem.seats.length < maxSeats) {
          this.activeItem.seats.push(this.createSeat(this.activeItem));
        } else {
          this.$emit(
            "alert",
            "Seats exceeded the max limit. Please resize the table and add."
          );
        }
      } else {
        this.$emit("alert", "Please select a table to add seats to.");
      }
    },
    cloneTable() {
      if (this.activeItem && this.activeItem.type) {
        let origTable = this.activeItem;
        if (this.activeItem.type == "seat") {
          origTable = this.tables.filter(
            t => t.id === this.activeItem.parentId
          )[0];
        }
        const tableClone = {};
        Object.assign(tableClone, origTable);
        const uniqId = `_${Math.random()
          .toString(36)
          .substr(2, 9)}`;
        tableClone.id = uniqId;
        const seatsClone = [];
        tableClone.seats.forEach(seat => {
          const seatClone = {};
          Object.assign(seatClone, seat);
          seatClone.parentId = tableClone.id;
          seatsClone.push(seatClone);
        });
        tableClone.x = tableClone.x + 30;
        tableClone.y = tableClone.y + 30;
        tableClone.seats = seatsClone;
        this.tables.push(tableClone);
        this.activeItem.active = false;
        tableClone.active = true;
        this.activeItem = tableClone;
      } else {
        this.$emit("alert", "Please select a table to clone.");
      }
    },
    removeItem() {
      if (this.activeItem) {
        if (this.activeItem.type == "table") {
          this.tables.splice(this.tables.indexOf(this.activeItem), 1);
        } else if (this.activeItem.type === "seat") {
          const parent = this.tables.filter(
            t => t.id === this.activeItem.parentId
          )[0];
          parent.seats.splice(parent.seats.indexOf(this.activeItem), 1);
        } else {
          this.$emit(
            "alert",
            "Cannot remove this item. Please select a table or a seat."
          );
        }
        this.activateDefaultItem();
      } else {
        this.$emit("alert", "Please select a table or seat to remove.");
      }
    },
    createTable() {
      const uniqId = `_${Math.random()
        .toString(36)
        .substr(2, 9)}`;
      const point = { x: 10, y: 10 };
      point.x = point.x + this.tables.length * 30;
      point.y = point.y + this.tables.length * 30;
      return {
        id: uniqId,
        type: "table",
        seats: [],
        active: false,
        x: point.x,
        y: point.y,
        width: 90,
        height: 60
      };
    },
    createSeat(activeTable) {
      const point = { x: 5, y: 5 };
      const numcols = activeTable.width / 30;
      const newSeatIndex = activeTable.seats.length;
      if (newSeatIndex < numcols) {
        point.x = point.x + newSeatIndex * 30;
      } else {
        point.y = point.y + 30;
        point.x = point.x + (newSeatIndex - numcols) * 30;
      }

      return {
        type: "seat",
        parentId: activeTable.id,
        _serviceKey: "",
        active: false,
        x: point.x,
        y: point.y,
        width: 20,
        height: 20,
        color: "#90ee90"
      };
    },
    activateDefaultItem() {
      this.tables.forEach(t => {
        if (t.active) t.active = false;
        t.seats.forEach(s => {
          if (s.active) s.active = false;
        });
      });
      //last seat in last table should be the default active
      const lastTableIndex = this.tables.length - 1;
      const lastTable = this.tables.length ? this.tables[lastTableIndex] : null;
      const lastSeat = lastTable
        ? lastTable.seats[lastTable.seats.length - 1]
        : null;
      this.activeItem = lastSeat ? lastSeat : lastTable;
      if (this.activeItem) this.activeItem.active = true;
    },
    onClickItem(event, item, tidx, sidx) {
      navigator.vibrate =
        navigator.vibrate ||
        navigator.webkitVibrate ||
        navigator.mozVibrate ||
        navigator.msVibrate;
      event.stopPropagation(); //prevent parent from firing
      //Toggle zoom if clicked on canvas (sends item as empty object{})
      this.zoomToFit =
        Object.keys(item).length === 0 ? !this.zoomToFit : this.zoomToFit;
      if (this.options.mode == "view") {
        if (item.type === "seat") {
          navigator.vibrate && navigator.vibrate([75]);
          this.$emit("onSelectSeat", {
            _serviceKey: item._serviceKey,
            tidx,
            sidx
          });
        }
      } else {
        if (item.active) return;
        if (this.activeItem && this.activeItem.active)
          this.activeItem.active = false;
        item.active = true;
        this.activeItem = item;
      }
    },
    moveLeft() {
      const item = this.activeItem;
      if (item) {
        if (item.type === "table") {
          item.x = item.x - 15;
        } else {
          item.x = item.x - 30;
        }
      }
    },
    moveRight() {
      const item = this.activeItem;
      if (item) {
        if (item.type === "table") {
          item.x = item.x + 15;
        } else {
          item.x = item.x + 30;
        }
      }
    },
    moveUp() {
      const item = this.activeItem;
      if (item) {
        if (item.type === "table") {
          item.y = item.y - 15;
        } else {
          item.y = item.y - 30;
        }
      }
    },
    moveDown() {
      const item = this.activeItem;
      if (item) {
        if (item.type === "table") {
          item.y = item.y + 15;
        } else {
          item.y = item.y + 30;
        }
      }
    },
    scaleUpX() {
      const item = this.activeItem;
      if (item) {
        if (item.type === "table") {
          item.width = item.width + 30;
        } else {
          this.$emit("alert", "Can't scale seat. Please select a table");
        }
      }
    },
    scaleDownX() {
      const item = this.activeItem;
      if (item) {
        if (item.type === "table") {
          item.width = item.width - 30;
        } else {
          this.$emit("alert", "Can't scale seat. Please select a table");
        }
      }
    },
    scaleUpY() {
      const item = this.activeItem;
      if (item) {
        if (item.type === "table") {
          item.height = item.height + 30;
        } else {
          this.$emit("alert", "Can't scale seat. Please select a table");
        }
      }
    },
    scaleDownY() {
      const item = this.activeItem;
      if (item) {
        if (item.type === "table") {
          item.height = item.height - 30;
        } else {
          this.$emit("alert", "Can't scale seat. Please select a table");
        }
      }
    },
    rotate(angle) {
      const item = this.activeItem;
      if (item) {
        if (item.type === "table") {
          item.angle = (item.angle || 0) + angle;
          this.$forceUpdate();
        } else {
          this.$emit("alert", "Can't rotate seat. Please select a table");
        }
      }
    },
    toggleShape() {
      const item = this.activeItem;
      if (item) {
        if (item.type === "table") {
          if (item.rx == 5 && item.rx == 5) {
            item.rx = 30;
            item.ry = 30;
          } else {
            item.rx = 5;
            item.ry = 5;
          }
          this.$forceUpdate();
        } else {
          this.$emit("alert", "Can't reshape seat. Please select a table");
        }
      }
    },
    onMouseDownRegion(event, item) {
      if (item.active) {
        const point = getEventPoint(event);
        this.point = point;
        item.drag = {
          type: "MOVE",
          x: item.x,
          y: item.y,
          mx: point.x,
          my: point.y
        };
      }
      this.movetarget = item;
    },
    onMouseUp(event, element) {
      this.movetarget = null;
      return element; //dummy
    },
    onMouseMove(event) {
      if (this.movetarget == null) return;
      let item = this.movetarget;
      let t = this.tools;

      if (item.active && item.drag != undefined) {
        const point = getEventPoint(event);
        this.point = point;
        const margin = item.type === "table" ? 10 : 5;
        if (item.drag.type == "MOVE") {
          item.x =
            Math.round((point.x - item.drag.mx + item.drag.x) / 30) * 30 +
            margin;
          item.y =
            Math.round((point.y - item.drag.my + item.drag.y) / 30) * 30 +
            margin;
        }
        if (item.drag.type == "SCALE") {
          if (item.drag.handleID == "1") {
            item.x = Math.min(
              point.x - item.drag.mx + item.drag.x,
              item.drag.x + (item.drag.w - t.min_height)
            );
            item.y = Math.min(
              point.y - item.drag.my + item.drag.y,
              item.drag.y + (item.drag.h - t.min_height)
            ); // with y constraint
            item.width = Math.max(
              Math.round((item.drag.w - point.x + item.drag.mx) / 30) * 30,
              t.min_height
            );
            item.height = Math.max(
              Math.round((item.drag.h - point.y + item.drag.my) / 30) * 30,
              t.min_height
            );
          }
          if (item.drag.handleID == "3") {
            item.y = Math.min(
              point.y - item.drag.my + item.drag.y,
              item.drag.y + (item.drag.h - t.min_height)
            ); // with y constraint
            item.width = Math.max(
              Math.round((item.drag.w + point.x - item.drag.mx) / 30) * 30,
              t.min_height
            );
            item.height = Math.max(
              Math.round((item.drag.h - point.y + item.drag.my) / 30) * 30,
              t.min_height
            );
          }
          if (item.drag.handleID == "7") {
            item.x = Math.min(
              point.x - item.drag.mx + item.drag.x,
              item.drag.x + (item.drag.w - t.min_height)
            );
            item.width = Math.max(
              Math.round((item.drag.w - point.x + item.drag.mx) / 30) * 30,
              t.min_height
            );
            item.height = Math.max(
              Math.round((item.drag.h + point.y - item.drag.my) / 30) * 30,
              t.min_height
            );
          }
          if (item.drag.handleID == "9") {
            item.width = Math.max(
              Math.round((item.drag.w + point.x - item.drag.mx) / 30) * 30,
              t.min_height
            );
            item.height = Math.max(
              Math.round((item.drag.h + point.y - item.drag.my) / 30) * 30,
              t.min_height
            );
          }
        }
      }
    },
    onMouseDownHandles(event, item) {
      let handleID = event.target.getAttribute("data-handleid");
      const point = getEventPoint(event);
      this.point = point;
      item.drag = {
        x: item.x,
        y: item.y,
        mx: point.x,
        my: point.y,
        w: item.width,
        h: item.height,
        type: "SCALE",
        handleID: handleID
      };
      this.movetarget = item;
    },
    onKeyUp(event) {
      if (event.key === "Delete") {
        this.removeItem();
      }
      return event.preventDefault();
    }
  }
};

function getEventPoint(event) {
  const point = { x: 0, y: 0 };
  if (event.type.startsWith("touch")) {
    point.x = event.touches[0].clientX;
    point.y = event.touches[0].clientY;
  } else {
    point.x = event.clientX;
    point.y = event.clientY;
  }
  return point;
}
</script>
<style lang="css">
svg .ctrl-rect {
  fill: #ffffff;
  stroke: #222222;
  stroke-width: 1;
}
svg .ctrl-bounds {
  fill-opacity: 0;
  stroke: #222222;
  stroke-width: 1;
  stroke-linecap: round;
  stroke-dasharray: 2, 4;
}
.canvas svg {
  background: "gray";
}
.toolbar {
  background-color: #f4ebec;
  border: 1px solid;
  border-radius: 5px;
}
.v-btn {
  margin: 1px 1px 1px 1px;
}
.canvas {
  border-radius: 5px;
  padding-top: 0px;
  margin-top: 0px;
  padding-right: 0px;
  margin-right: 0px;
  padding-bottom: 0px;
  margin-bottom: 0px;
  padding-left: 0px;
  margin-left: 0px;
}
</style>